import React from "react";

function BreadcrumbSchema({ productData }) {

  // Build breadcrumb items dynamically
  const breadcrumbItems = [
    {
      "@type": "ListItem",
      "position": 1,
      "name": "Home",
      "item": "https://ashnavaswani.com/"
    },
   
  ];

  // Optional: category breadcrumb
  // if (productData?.category_name && productData?.category_slug) {
  //   breadcrumbItems.push({
  //     "@type": "ListItem",
  //     "position": 3,
  //     "name": productData.category_name,
  //     "item": `https://ashnavaswani.com/category/${productData.category_slug}`
  //   });
  // }

  // Product breadcrumb (last)
  breadcrumbItems.push({
    "@type": "ListItem",
    "position": breadcrumbItems.length + 1,
    "name": productData.product_name,
    "item": `https://ashnavaswani.com/product/${productData.product_slug}`
  });

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": breadcrumbItems
  };

  return (
    <script type="application/ld+json">
      {JSON.stringify(breadcrumbSchema)}
    </script>
  );
}

export default BreadcrumbSchema;
